import React from "react";
import { useForm } from "@refinedev/react-hook-form";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Switch } from "@/components/ui/switch";
import { FormField } from "@/components/ui/form-field";
import { EditPage } from "@/components/crud";
import { IAddress } from "../../types";

export const AddressEdit: React.FC = () => {
  const {
    refineCore: { onFinish, formLoading },
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    watch,
  } = useForm<IAddress>();

  return (
    <EditPage>
      <form onSubmit={handleSubmit(onFinish)}>
        <Card>
          <CardHeader>
            <CardTitle>Address Information</CardTitle>
          </CardHeader>
          <CardContent className="space-y-4">
            <FormField label="Street Address" required error={errors.street?.message as string}>
              <Input {...register("street", { required: "Please input the street address!" })} placeholder="Enter street address" />
            </FormField>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <FormField label="City" required error={errors.city?.message as string}>
                <Input {...register("city", { required: "Please input the city!" })} placeholder="Enter city" />
              </FormField>
              <FormField label="State/Province">
                <Input {...register("state")} placeholder="Enter state or province" />
              </FormField>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <FormField label="Postal Code">
                <Input {...register("postal_code")} placeholder="Enter postal code" />
              </FormField>
              <FormField label="Country" required error={errors.country?.message as string}>
                <Input {...register("country", { required: "Please input the country!" })} placeholder="Enter country" />
              </FormField>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <FormField label="Latitude">
                <Input type="number" step="0.000001" min={-90} max={90} {...register("latitude")} placeholder="Enter latitude" />
              </FormField>
              <FormField label="Longitude">
                <Input type="number" step="0.000001" min={-180} max={180} {...register("longitude")} placeholder="Enter longitude" />
              </FormField>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <FormField label="Address Type" required error={errors.address_type?.message as string}>
                <select
                  className="flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm"
                  {...register("address_type", { required: "Please select address type!" })}
                >
                  <option value="">Select address type</option>
                  <option value="billing">Billing</option>
                  <option value="shipping">Shipping</option>
                  <option value="office">Office</option>
                  <option value="other">Other</option>
                </select>
              </FormField>
              <FormField label="Primary Address">
                <Switch
                  checked={watch("is_primary") ?? false}
                  onCheckedChange={(v) => setValue("is_primary", v)}
                />
              </FormField>
            </div>
          </CardContent>
        </Card>
        <div className="flex justify-end mt-6">
          <Button type="submit" disabled={formLoading}>Save</Button>
        </div>
      </form>
    </EditPage>
  );
};
